import { useState } from 'react';
import { Rocket } from 'lucide-react';


const faqs = [
  {
    question: '1. What exactly is Alfa Entrepreneurs?',
    answer: 'Alfa Entrepreneurs is more than just a business community, it\'s a family of passionate, like-minded entrepreneurs who understand the real, raw struggles of building a business from the ground up. We’re here to support, mentor, and grow with each other, ensuring no entrepreneur feels alone in their journey.'
  },
  
  {
    question: '2. Who can join Alfa Entrepreneurs?',
    answer: 'Anyone with an entrepreneurial mindset! Whether you\'re just starting, managing a small or medium-scale business, or looking to reinvent your venture, you belong here. If you’re ready to grow, share, and learn with others, Alfa Entrepreneurs is the place for you.',
  },
  {
    question: '3. How can Alfa Entrepreneurs help me grow my business?',
    answer: 'Through mentorship, networking, expert resources, and a supportive community. You’ll gain access to experienced entrepreneurs who’ve faced the same hurdles as you, participate in events that foster collaboration, and use shared knowledge to avoid common pitfalls and unlock new growth opportunities.',
  },
  {
    question: '4. What kind of support can I expect from the community?',
    answer: 'Emotional, strategic, and practical. From brainstorming ideas to dealing with fear and burnout, from marketing advice to financial planning, Alfa Entrepreneurs is a space where your voice is heard, your problems are understood, and real solutions are shared.',
  },
  {
    question: '5. How is Alfa Entrepreneurs different from other business communities?',
    answer: 'We\'re not about just networking or passing business cards. We’re about walking together, through wins and struggles. We focus deeply on mental health, mentorship, and authentic connection because we know building a business isn’t just a process; it’s a personal journey.',
  },
  {
    question: '6. Is there a cost to join Alfa Entrepreneurs?',
    answer: 'Our community values commitment more than cost. While certain events or premium resources may have a fee, becoming part of our core community starts with your willingness to engage, grow, and support. And we’ll make sure the value you receive always outweighs what you invest.',
  },
  
  {
    question: '7. How can I get involved in the community?',
    answer: 'It’s simple: sign up, introduce yourself, and show up. Start by connecting with other members, joining events, and accessing the available resources. From day one, you’ll realize you’re no longer walking alone. This is the start of your transformation into an Alfa Entrepreneur.',
  },
  
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="p-6 md:w-full">
      <h2 className="text-2xl font-semibold text-gray-900">Frequently Asked Questions</h2>
      <p className="mt-4 text-gray-600 mb-4">
        Have questions? We have answers! Click to expand answers.
      </p>
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div key={index} className="border-b pb-4">
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex justify-between items-center text-left font-medium text-gray-800"
            >
              {faq.question}
              <span className="text-indigo-600 text-xl">{openIndex === index ? '-' : '+'}</span>
            </button>
            {openIndex === index && (
              <p className="mt-2 text-gray-600">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};




export default function HomePage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center">
          <Rocket className="mx-auto h-12 w-12 text-indigo-600" />
          <h1 className="mt-4 text-4xl font-bold text-gray-900 sm:text-5xl">
            Welcome to Alfa Entrepreneur 
          </h1>
          <div className='home-content'>
          <p className="mt-4 text-xl text-gray-500">
          Alfa Entrepreneur is a membership site designed to help you build a successful career in B2B marketing. Get access to an online resource that’s jam packed with helpful content and a private community where you can ask questions, get feedback, and exchange ideas with peers.
          </p>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <img
              src="/HomeArticle.jpg"
              alt="Tech Learning"
              className="h-48 w-full object-cover"
            />
            <div className="p-6">
              <h3 className="text-lg font-semibold text-gray-900">Latest Articles</h3>
              <p className="mt-2 text-gray-600">Explore our curated collection of Marketing articles</p>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <img
              src="/HomePodcast.jpg"
              alt="Tech Podcast"
              className="h-48 w-full object-cover"
            />
            <div className="p-6">
              <h3 className="text-lg font-semibold text-gray-900">Marketing Podcasts</h3>
              <p className="mt-2 text-gray-600">Listen to industry experts share their insights</p>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <img
              src="/JoinCommunity.jpg"
              alt="Community"
              className="h-48 w-full object-cover"
            />
            <div className="p-6">
              <h3 className="text-lg font-semibold text-gray-900">Join Our Community</h3>
              <p className="mt-2 text-gray-600">Connect with like-minded Marketing enthusiasts</p>
            </div>
          </div>
        </div>
      </div>
      <div>
              {/* About Us Section */}
              <div className="mt-12 bg-white rounded-lg shadow-lg overflow-hidden flex flex-col md:flex-row">
                <img
                  src="/ourmission.png"
                  alt="Team"
                  className="h-60 w-full object-cover md:w-1/3 p-2 m-2"
                />
                <div className="p-6 md:w-3/4">
                  <h2 className="text-2xl font-semibold text-gray-900">About Us</h2>
                  <p className="mt-4 text-gray-600">
                    A warm welcome to Alfa Entrepreneurs, a community where entrepreneurs join hands to transform their businesses.
                    We are a community of like-minded, passionate entrepreneurs who relate to the battles of running a business in the dark. 
                    We understand how it feels to be underappreciated, looked past, and even run your business unaided. Your presence at Alfa 
                    Entrepreneurs will be noticed. Your problems will be discussed. We understand that entrepreneurship is a lonesome voyage,
                    but you aren’t travelling alone.
                  </p>
                </div>
              </div>
              {/* Our Mission Section */}
              <div className="mt-12 bg-white rounded-lg shadow-lg overflow-hidden flex flex-col-reverse md:flex-row">
                  <div className="p-6 md:w-2/3">
                    <h2 className="text-2xl font-semibold text-gray-900">Our Mission</h2>
                    <p className="mt-4 text-gray-600">
                      At Alfa Entrepreneurs, we aim to empower small and medium-scale entrepreneurs to stand against their challenges. 
                      To claim a rightful place in society, entrepreneurs like you and me need to help and learn from each other. 
                      We believe that walking alone is necessary to move ‘fast’, but walking together is necessary to go ‘far’.
                      Our mission is to turn all of you into an Alfa Entrepreneur—a changemaker who’ll drive change, a leader who 
                      signifies one’s supremacy and is recognized for their contribution.
                    </p>
                  </div>
                    <img
                      src="/mission.jpg"
                      alt="Our Mission"
                      className="h-60 w-full object-cover md:w-1/3 p-2 m-2"
                    />
              </div>
              {/* FAQ Section */}
              
              <div className="mt-12 bg-white rounded-lg shadow-lg overflow-hidden flex flex-col">
                  <FAQ />
              </div>

              {/* Contact Us */}
              <div className="mt-12 bg-white rounded-lg shadow-lg overflow-hidden flex flex-col md:flex-row">
                <img
                  src="ContactUsImage.jpg"
                  alt="Contact Us"
                  className="h-60 w-full object-cover md:w-1/3 p-2 m-2"
                />
                <div className="p-6 md:w-3/4">
                  <h2 className="text-2xl font-semibold text-gray-900">Contact Us</h2>
                  <p className="mt-4 text-gray-600">
                    Have questions or feedback? We’d love to hear from you! Reach out to us at:
                    <br />
                    Email: <a href="mailto:admin@alfaentrepreneur.com" className="text-indigo-600">admin@alfaentrepreneur.com</a>
                    <br />
                    Phone: <a href="tel:+1234567890" className="text-indigo-600">+91 89204 31091</a>
                  </p>
                </div>        
              </div>
        </div>
    </div>
  );
}